// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "subscriptions".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { subscriptionStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "subscriptions" table (1:1 with a DB row, on the wire). */
export const subscriptionsAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    stripeCustomerId: z.string(),
    stripeSubscriptionId: z.string().nullable(),
    stripePriceId: z.string().nullable(),
    status: z.enum(subscriptionStatusValues),
    planId: z.string(),
    currentPeriodStart: z.string().datetime().nullable(),
    currentPeriodEnd: z.string().datetime().nullable(),
    cancelAtPeriodEnd: z.boolean(),
    canceledAt: z.string().datetime().nullable(),
    endedAt: z.string().datetime().nullable(),
    trialStart: z.string().datetime().nullable(),
    trialEnd: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=subscriptions.js.map